import map from 'lodash/map';
import isEqual from 'lodash/isEqual';

function getComponentsAndOptions(configuration) {
  return map(configuration?.optionclassifications, oc => ({
    identifier: oc.identifier,
    selectedoptions: map(oc.selectedoptions, o => ({
      identifier: o.identifier,
    })),
  }));
}

export function isOriginalConfiguration(configuration1, configuration2) {
  return isEqual(getComponentsAndOptions(configuration1), getComponentsAndOptions(configuration2));
}

export function hasDesign(configuration) {
  return Object.values(configuration.designdata || {}).some(({ canvasData }) => canvasData?.objects?.length);
}

export function showRequestQuoteButton(configuratorState) {
  return !(configuratorState.hasDesign && configuratorState.isOriginal);
}

export function getShowRequestQuoteButtonWithLevel(level) {
  switch (level) {
    case 1:
      return false
  case 2: case 3:
    return true
  default: return null
  }
}
